import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import {
  BooleanFeatureFlagDirective,
  EvaluationContext,
  InMemoryProvider,
  OpenFeatureModule,
} from '@openfeature/angular-sdk';

interface IEvaluationContext extends EvaluationContext {
  user?: { email: string };
}

const FLAG_CONFIGURATION = Object.entries(
  environment.__unstable__featureFlags,
).reduce((acc, [featureKey, featureConfig]) => {
  return {
    ...acc,
    [featureKey]: {
      variants: {
        on: true,
        off: false,
      },
      disabled: false,
      defaultVariant: featureConfig.released ? 'on' : 'off',
      contextEvaluator: ({ user }: IEvaluationContext) => {
        if (user) {
          if (featureConfig.released) {
            return 'on';
          }
          return featureConfig.whitelist.includes(user.email) ? 'on' : 'off';
        }
        return featureConfig.released ? 'on' : 'off';
      },
    },
  };
}, {});

const InMemoryOpenFeatureModule = OpenFeatureModule.forRoot({
  provider: new InMemoryProvider(FLAG_CONFIGURATION),
});

@NgModule({
  imports: [
    CommonModule,
    InMemoryOpenFeatureModule,
    BooleanFeatureFlagDirective,
  ],
  exports: [BooleanFeatureFlagDirective],
})
export class FeatureModule {}
